<template>
    <b-form-select
        :class="{ 'has-selection': day !== null }"
        :dusk="'dusk' + name"
        :name="name"
        :options="options"
        :value="day"
        @change="updateValue"
        class="jgile-day-picker"
    >
        <template slot="first">
            <option :value="null" disabled>{{ placeholder }}</option>
        </template>
        <slot></slot>
    </b-form-select>
</template>

<script>
import moment from 'moment';

export default {
    props: {
        name: {
            type: String,
            default: 'day',
        },
        placeholder: {
            type: String,
            default: '-- Please select an option --',
        },
        monthPicker: {
            type: String,
            default: null,
        },
        value: {},
    },
    data() {
        return {
            day: null,
            month: 1,
        };
    },
    created() {
        Bus.$on('jgileMonthPicker', this.setMonth);
    },
    beforeDestroy() {
        Bus.$off('jgileMonthPicker', this.setMonth);
    },
    methods: {
        updateValue(newVal) {
            this.$emit('input', newVal);
        },
        setMonth(newVal) {
            if (this.monthPicker) {
                if (newVal.monthPicker === this.monthPicker) {
                    this.month = newVal.value;
                }
            }
        },
    },
    computed: {
        options() {
            return _.map(_.range(moment(this.month, 'M').daysInMonth()), (day) => {
                return { value: day + 1, text: day + 1 };
            });
        },
    },
    watch: {
        value: {
            immediate: true,
            handler(newVal) {
                this.day = newVal;
            },
        },
    },
};
</script>
